// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".disable-auth-provider.card-container{box-shadow:none}.disable-auth-provider #confirm{width:90%;margin-left:3px}.disable-auth-provider .remove-modal{border-radius:var(--border-radius);overflow:scroll;max-height:100vh}.disable-auth-provider .remove-modal ::-webkit-scrollbar-corner{background:transparent}.disable-auth-provider .actions{text-align:right}.disable-auth-provider .card-actions{display:flex}.disable-auth-provider .card-actions .spacer{flex:1}", ""]);
// Exports
module.exports = exports;
